'use client';
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var _span;
import * as React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import composeClasses from '@mui/utils/composeClasses';
import capitalize from "../utils/capitalize.js";
import Typography from "../Typography/index.js";
import FormControlContext from "../FormControl/FormControlContext.js";
import useFormControl from "../FormControl/useFormControl.js";
import { styled } from "../zero-styled/index.js";
import memoTheme from "../utils/memoTheme.js";
import { useDefaultProps } from "../DefaultPropsProvider/index.js";
import inputAdornmentClasses, { getInputAdornmentUtilityClass } from "./inputAdornmentClasses.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var overridesResolver = function(props, styles) {
    var ownerState = props.ownerState;
    return [
        styles.root,
        styles["position".concat(capitalize(ownerState.position))],
        ownerState.disablePointerEvents === true && styles.disablePointerEvents,
        styles[ownerState.variant]
    ];
};
var useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes, disablePointerEvents = ownerState.disablePointerEvents, hiddenLabel = ownerState.hiddenLabel, position = ownerState.position, size = ownerState.size, variant = ownerState.variant;
    var slots = {
        root: [
            'root',
            disablePointerEvents && 'disablePointerEvents',
            position && "position".concat(capitalize(position)),
            variant,
            hiddenLabel && 'hiddenLabel',
            size && "size".concat(capitalize(size))
        ]
    };
    return composeClasses(slots, getInputAdornmentUtilityClass, classes);
};
var InputAdornmentRoot = styled('div', {
    name: 'MuiInputAdornment',
    slot: 'Root',
    overridesResolver: overridesResolver
})(memoTheme(function(param) {
    var theme = param.theme;
    return {
        display: 'flex',
        maxHeight: '2em',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        color: (theme.vars || theme).palette.action.active,
        variants: [
            {
                props: {
                    variant: 'filled'
                },
                style: _define_property({}, "&.".concat(inputAdornmentClasses.positionStart, "&:not(.").concat(inputAdornmentClasses.hiddenLabel, ")"), {
                    marginTop: 16
                })
            },
            {
                props: {
                    position: 'start'
                },
                style: {
                    marginRight: 8
                }
            },
            {
                props: {
                    position: 'end'
                },
                style: {
                    marginLeft: 8
                }
            },
            {
                props: {
                    disablePointerEvents: true
                },
                style: {
                    pointerEvents: 'none'
                }
            }
        ]
    };
}));
var InputAdornment = /*#__PURE__*/ React.forwardRef(function InputAdornment(inProps, ref) {
    var props = useDefaultProps({
        props: inProps,
        name: 'MuiInputAdornment'
    });
    var children = props.children, className = props.className, _props_component = props.component, component = _props_component === void 0 ? 'div' : _props_component, _props_disablePointerEvents = props.disablePointerEvents, disablePointerEvents = _props_disablePointerEvents === void 0 ? false : _props_disablePointerEvents, _props_disableTypography = props.disableTypography, disableTypography = _props_disableTypography === void 0 ? false : _props_disableTypography, position = props.position, variantProp = props.variant, other = _object_without_properties(props, [
        "children",
        "className",
        "component",
        "disablePointerEvents",
        "disableTypography",
        "position",
        "variant"
    ]);
    var muiFormControl = useFormControl() || {};
    var variant = variantProp;
    if (variantProp && muiFormControl.variant) {
        if (process.env.NODE_ENV !== 'production') {
            if (variantProp === muiFormControl.variant) {
                console.error('MUI: The `InputAdornment` variant infers the variant prop ' + 'you do not have to provide one.');
            }
        }
    }
    if (muiFormControl && !variant) {
        variant = muiFormControl.variant;
    }
    var ownerState = _object_spread_props(_object_spread({}, props), {
        hiddenLabel: muiFormControl.hiddenLabel,
        size: muiFormControl.size,
        disablePointerEvents: disablePointerEvents,
        position: position,
        variant: variant
    });
    var classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ _jsx(FormControlContext.Provider, {
        value: null,
        children: /*#__PURE__*/ _jsx(InputAdornmentRoot, _object_spread_props(_object_spread({
            as: component,
            ownerState: ownerState,
            className: clsx(classes.root, className),
            ref: ref
        }, other), {
            children: typeof children === 'string' && !disableTypography ? /*#__PURE__*/ _jsx(Typography, {
                color: "textSecondary",
                children: children
            }) : /*#__PURE__*/ _jsxs(React.Fragment, {
                children: [
                    position === 'start' ? /* notranslate needed while Google Translate will not fix zero-width space issue */ _span || (_span = /*#__PURE__*/ _jsx("span", {
                        className: "notranslate",
                        "aria-hidden": true,
                        children: "\u200B"
                    })) : null,
                    children
                ]
            })
        }))
    });
});
process.env.NODE_ENV !== "production" ? InputAdornment.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component, normally an `IconButton` or string.
   */ children: PropTypes.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: PropTypes.object,
    /**
   * @ignore
   */ className: PropTypes.string,
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: PropTypes.elementType,
    /**
   * Disable pointer events on the root.
   * This allows for the content of the adornment to focus the `input` on click.
   * @default false
   */ disablePointerEvents: PropTypes.bool,
    /**
   * If children is a string then disable wrapping in a Typography component.
   * @default false
   */ disableTypography: PropTypes.bool,
    /**
   * The position this adornment should appear relative to the `Input`.
   */ position: PropTypes.oneOf([
        'end',
        'start'
    ]).isRequired,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.oneOfType([
            PropTypes.func,
            PropTypes.object,
            PropTypes.bool
        ])),
        PropTypes.func,
        PropTypes.object
    ]),
    /**
   * The variant to use.
   * Note: If you are using the `TextField` component or the `FormControl` component
   * you do not have to set this manually.
   */ variant: PropTypes.oneOf([
        'filled',
        'outlined',
        'standard'
    ])
} : void 0;
export default InputAdornment;
